<template>
	<div class="recharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.go(-1)"></div>
			<div class="big_tit">{{$t('invest.recharge')}}</div>
		</div>
		<div class="balance" v-if="eye==1">
			<p>
				{{$t('invest.availableBalance')}}
				<van-icon name="eye" @click="eye=0" />
			</p>
			<p>
				{{balance}}
			</p>
		</div>
		<div class="balance" v-if="eye==0">
			<p>
				{{$t('invest.availableBalance')}}
				<van-icon name="closed-eye" @click="eye=1" />
			</p>
			<p>
				******
			</p>
		</div>
		<form class="form">
			<div class="recharge_wrap">
				<!-- <p>{{$t('invest.rechargeAmount')}}</p> -->
				<div class="form-cell">
					<div class="flex_bd">
						<input v-model.trim="data.money" type="number" step="0.01" class="inp"
							:placeholder="$t('invest.rechargeAmount')" @input="changeAmount">
					</div>
					<span class="unit">
						<!-- <img src="../images/user/usdt.png" alt=""> -->
						{{$t('utils.moneyMark2')}}
					</span>
				</div>
				<!-- <div>
					<span>{{actualAmount}}</span>
				</div> -->
			</div>
			<div class="recharge_fs">
				<div class="tit">
					{{$t('invest.paymentMethod')}}
				</div>
				<div class="recharge_cells">
					<div v-for="(v, k) in config.payment" :key="k" class="item" @click="choose_type(k+1,v)">
						<div class="re_icon"><img :src="v.logo" /></div>
						<div class="re_name">
							{{ v.name }}
						</div>
						<div class="check" :class="k+1 == data.choose? 'checked' : ''" />
					</div>
					<!-- <div class="item" @click="choose_type(9999,'')">
						<div class="re_icon"><img src="../images/user/logo2.small.png" /></div>
						<div class="re_name">
							BastPay
						</div>
						<div class="check" :class="9999 == data.choose? 'checked' : ''" />
					</div> -->
				</div>
			</div>
		</form>
		<div class="basic_btn sbtn" @click="showbankinfo()">
			{{$t('invest.next')}}
		</div>
		<van-dialog v-model="show_tz" theme="round-button" @confirm="submit" :confirmButtonText="$t('utils.submit')"  style="top:50%;background-color: #200a6e;">
			<div class="close-x" @click="show_tz = false"><van-icon name="cross" /></div>
			<div class="show-body">
				<div class="sw-cell">
					<div class="sw-label">{{$t('invest_bank.bank')}}</div>
					<div class="sw-bar">
						<div class="flex_bd">
							<van-field v-model="payment.name" disabled type="text" style="background-color: #200a6e;" />
						</div>
						<div class="copy_btn ut" v-clipboard="() => payment.name " v-clipboard:success="copy">
							{{$t('invest_bank.copy')}}
						</div>
					</div>
				</div>
				<div class="sw-cell">
					<div class="sw-label">{{$t('invest_bank.account')}}</div>
					<div class="sw-bar">
						<div class="flex_bd">
							<van-field v-model="payment.account" disabled type="text" style="background-color: #200a6e;" />
						</div>
						<div class="copy_btn ut" v-clipboard="() => payment.account " v-clipboard:success="copy">
							{{$t('invest_bank.copy')}}
						</div>
					</div>
				</div>
				<div class="sw-cell">
					<div class="sw-label">{{$t('invest_bank.name')}}</div>
					<div class="sw-bar">
						<div class="flex_bd">
							<van-field v-model="payment.user" disabled type="text" style="background-color: #200a6e;" />
						</div>
						<div class="copy_btn ut" v-clipboard="() => payment.user " v-clipboard:success="copy">
							{{$t('invest_bank.copy')}}
						</div>
					</div>
				</div>
				
				<div class="qrcode sw-cell">
					<div class="sw-label">{{$t('invest_bank.rec_img')}}</div>
					<div class="qrcode_img">
						<van-uploader v-model="fileList" multiple :max-count="1" class="upload" :max-size="12 * 1024 * 1024" @oversize="onOversize" :after-read="afterRead1"
							:before-read="beforeRead">
						</van-uploader>
					</div>
				</div>
			</div>
			
		</van-dialog>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		CountDown,
		Checkbox,
		RadioGroup,
		Uploader,
		Field,
		Icon,
		Radio,Toast
	} from 'vant';
	import {
		jsBridge
	} from '../../utils/jsbridge-mini.js';
	import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import Clipboard from "v-clipboard";
    import axios from 'axios'

	Vue.use(RadioGroup).use(Field).use(Uploader);
	Vue.use(Radio);
	Vue.use(CountDown).use(Checkbox).use(Icon).use(Clipboard);

	export default {
		name: "invest",
		data() {
			return {
				time: 0,
				eye: 1,
				balance: 0.00,
				data: {
					choose: '',
					channel: '',
					money: '',
					id: '',
					realimg1: ''
				},
				payment: [],
				config: {},
				actualAmount: '',
				show_tz: false,
				number: 0,
				fileList:[]
			};
		},
		created() {
			this.$parent.footer('user', false);
		},
		mounted() {
			this.start();
		},
		methods: {
			onOversize(file) {
			    this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
			    if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
			        this.$toast(this.$t('account.supportPicture'));
			        return false;
			    }
			    return true;
			},
			afterRead1(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
				
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.data.realimg1 = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			},
			start() {
				Fetch('/user/recharge', {
					...this.data
				}).then((r) => {
					this.balance = r.data.money;
					this.config = r.data;
					this.config.min_recharge = parseInt(this.config.min_recharge);
					this.choose_type(1, r.data.payment[0]);
				});
			},
			copy() {
				console.log(123)
				this.$toast({
					className:"toastName",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			checkLimit() {
				const key = 'invest_button';
				const ttl = 60;
				let now = Date.parse(new Date()) / 1000;
				let val = localStorage.getItem(key);
				if (!val) {
					val = JSON.stringify({
						'ttl': now + ttl
					})
					localStorage.setItem(key, val)
					return true;
				} else {
					val = JSON.parse(val);
					if (val['ttl'] > now) {
						return false;
					} else {
						val = JSON.stringify({
							'ttl': now + ttl
						})
						localStorage.setItem(key, val)
						return true;
					}
				}
			},
			choose_type(k, payment) {
				this.data.choose = k;
				this.data.channel = payment.type;
				this.data.id = payment.id;
				this.payment = payment;
				this.changeAmount();
			},
			showbankinfo(){
				if (!this.data.money || this.data.money < this.config.min_recharge) {
					this.$toast({
						className:"toastName",
						message: this.$t('invest.rechargeAmountLow') + this.$t('utils.moneyMark') + this.config
						.min_recharge + this.$t('invest.rechargeAmountLow1')
					});
					return false;
				}

				if(this.data.choose==9999){
					this.onliepay();
				}
				else{
					
					if (!this.data.channel) {
						this.$toast({
							className:"toastName",
							message: this.$t('invest.paymentMethodEmpty')
						});
						return false;
					}
					this.show_tz = true;
				}
			},
			// submitBtn() {
			// 	Fetch("/user/recharge_apply", {
			// 		id: this.data.orderId
			// 	}).then((r) => {
			// 		if (r.code == 1) {
			// 			this.$toast({
			// 				background: "#07c160",
			// 				message: this.$t('invest_qrcode.submittedSuccessfully'),
			// 			});
			// 			this.$router.replace("/moneybag");
			// 		}
			// 	});
			// },
			onliepay(){
				Fetch("/user/recharge_vietpay", {
					...this.data
				}).then((r) => {
					var re =  r.data; 
					//console.log(re);
					if (r.code == 1) {
						location.href=r.data;
					}else{
						alert(r.info);
					} 
				});
				return;
			},
			submit() {
				if (!this.data.money || this.data.money < this.config.min_recharge) {
					this.$toast({
						className:"toastName",
						message: this.$t('invest.rechargeAmountLow') + this.$t('utils.moneyMark') + this.config
						.min_recharge + this.$t('invest.rechargeAmountLow1')
					});
					return false;
				}
				if (!this.data.channel) {
					this.$toast({
						className:"toastName",
						message: this.$t('invest.paymentMethodEmpty')
					});
					return false;
				}
				if (!this.data.realimg1) {
					this.$toast({
						className:"toastName",
						message: this.$t('invest.paymentImgEmpty')
					});
					return false;
				}
				// if (!this.checkLimit()) {
				// 	this.$toast(this.$t('invest.overtop'));
				// 	return false;
				// }
				// console.log(this.data);
				// return false;

				//console.log( this.data.channel);
				if (this.data.channel == 4) {
					///invest/bank',
					Fetch("/user/recharge_type", {
						...this.data
					}).then((r) => {
						var re =  r.data; 
						//console.log(re);
						if (r.code == 1) {
							this.$toast({
								background: "#07c160",
								message: this.$t('invest_qrcode.submittedSuccessfully'),
							});
							this.$router.replace("/moneybag");
						}else{
							alert(re.message);
						} 
					});
					return;
				} else if (this.data.channel == 2) {
					this.$router.replace({
						path: '/invest/alipay',
						query: {
							money: this.data.money,
							type: this.data.channel,
							id: this.data.id
						}
					})
					return;
				} else if (this.data.channel == 3) {
					this.$router.replace({
						path: '/invest/wx',
						query: {
							money: this.data.money,
							type: this.data.channel,
							id: this.data.id
						}
					})
					return;
				} else if (this.data.channel == 1) {
					this.$router.replace({
						path: '/invest/usdt',
						query: {
							money: this.data.money,
							id: this.data.id
						}
					})
					return;
				}else if (this.data.channel == 5) {
					// Fetch('/user/invest/apply', {
					//     ...this.data
					// }).then(() => {
					//     this.$router.replace('/login');
					// });
					let that = this; 
					console.log( this.data.money);
					Fetch("/user/recharge_type", {
						money: this.data.money,
						id: this.data.id
					}).then((r) => {
						var re =  r.data; 
						console.log(re);
						if(re.code == 0)
						{
							// this.$router.replace(re.data.qr_code);
							window.location.href = re.data.qr_code;
						}else{
							alert(re.message);
						} 
					});
					return;
				} else {
					this.$router.replace({
						path: '/invest/' + this.data.channel,
						query: {
							money: this.data.money,
						}
					});
				}
				// Fetch('/user/invest/apply', {
				//     ...this.data
				// }).then(() => {
				//     this.$router.replace('/login');
				// });
			},
			changeAmount() {
				var num = 2;
						//console.log(this.payment)
				if (this.payment.type) {
					if (this.payment.type == 1) {
						if (this.payment.rate > 10000) {
							num = 8;
						} else if (this.payment.rate > 1000) {
							num = 6;
						} else if (this.payment.rate > 10) {
							num = 4;
						}
						//console.log(this.payment)
						this.actualAmount = "≈" + (this.data.money / this.payment.rate).toFixed(num) + this.payment.mark;
					} else {
						this.actualAmount = "≈" + this.payment.mark + (this.data.money / this.payment.rate).toFixed(0);
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		height: 168px;
		//background-image: url(../images/user/moneybag/bg.png);
		position: fixed;
		//background-position: center;
		//background-repeat: no-repeat;
		//background-size: 100% 100%;
	}

	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #FFFFFF;
		top: 36px;
		right: 14px;
	}

	.balance {
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		padding: 15px 0px 25px;
		box-shadow: 2px 2px 5px rgba(115, 115, 115, .35);
		position: absolute;
		top: 74px;
		left: 15px;
		right: 15px;
		text-align: center;

		p:nth-child(1) {
			font-size: 12px;
			color: #999999;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;

			.van-icon {
				font-size: 20px;
				margin-left: 4px;
				color: #c2c2c2;
			}
		}

		p:nth-child(2) {
			color: #ff5551;
			font-size: 24px;
			font-weight: bold;
		}
	}

	.recharge_cells {
		background-color: #fff;
		padding: 0 15px;
	}

	.recharge_box {
		width: 100%;
		height: 48px;
		background: rgba(255, 255, 255, 1);
		border-radius: 6px;
		margin-top: 12px;
		padding: 16px 11px;

		input {
			height: 18px;
			width: 100%;
			line-height: 18px;
			font-size: 14px;
		}
	}

	.form {
		margin-top: 182px;

		.recharge_wrap {
			padding: 0 15px;

			.form-cell {
				padding: 10px;
				background: rgba(255, 255, 255, 1);
				border-radius: 5px;
				box-shadow: 2px 2px 5px rgba(115, 115, 115, .35);
				display: flex;
				align-items: center;
				background-color: #FFF;

				.flex_bd {
					flex: 1;

					input {
						height: 25px;
						width: 100%;
						line-height: 25px;
						font-size: 14px;
					}
				}

				.unit {
					color: #666666;
					display: flex;
					align-items: center;
					font-size: 12px;

					img {
						width: 16px;
						height: 16px;
						margin-right: 5px;
					}
				}
			}

			div:nth-child(2) {
				text-align: right;
				color: #666666;
				margin-top: 8px;
			}
		}

		.tit {
			border-bottom: 1px solid #ebe9e9;
			font-size: 16px;
			padding: 15px;
			color: #ffffff;
		}

		.item {
			height: 40px;
			border-bottom: 1px solid #ECECEC;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			&:last-child {
				border-bottom: none;
			}

			.check {
				width: 16px;
				height: 16px;
				margin-left: 4px;
				background: url(../images/user/c2.png) no-repeat center center;
				background-size: 100% 100%;

				&.checked {
					background: url(../images/user/c1.png) no-repeat center center;
					background-size: 100% 100%;
				}
			}

			.re_icon {
				width: 20px;
				height: 20px;
				margin-right: 5px;

				img {
					width: 20px;
					height: 20px;
				}
			}

			.re_name {
				font-size: 12px;
				flex: 1;
				line-height: 22px;
				color: #333333;
				margin-left: 4px;
			}

			.wx {
				background: url(../images/user/recharge3.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.usdt {
				background: url(../images/user/recharge1.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.alipay_app {
				background: url(../images/user/recharge2.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.bank {
				background: url(../images/user/recharge4.png) no-repeat center center;
				background-size: 100% 100%;
			}
		}
	}

	.sbtn {
		width: 213px;
		height: 35px;
		line-height: 35px;
		font-size: 12px;
		margin: 17px auto;
	}
	.show-body{
		padding: 20px;
		font-size: 14px;
		.sw-label{
			margin: 10px 0;
			color:#ffffff;
		}
		.sw-bar{
			display: flex;
			align-items: center;
			background-color: #180658;
			padding: 10px;
			border-radius: 4px;
			.flex_bd{
				color: #999999;
				.van-cell{
					padding: 2px 10px;
				}
			}
		}
	}
	.sw-grid{
		display: flex;
		align-items: flex-end;
		margin-top: 20px;
		.sw-row:first-child{
			margin-bottom:20px;
		}
		.sw-row > div:first-child{
			margin-bottom: 10px;
		}
		
		.sw-info{
			color: #999;
		}
		.sw-val.text-green{
			font-size: 16px;
		}
	}
	.sw-right{
		text-align: center;
		.sw-lg{
			font-size: 20px;
			margin-bottom: 10px;
		}
	}
	
	.copy_btn {
		color: #3d96ff;
		font-size: 12px;
		margin-left: 10px;
	}
	.close-x{
		color: #999;
		position: absolute;
		right: 12px;
		top: 12px;
	}
	.close-x .van-icon{
		font-size: 20px;
	}
	.qrcode{
		//padding-top: 30px;
		//padding-bottom: 30px;
		//text-align: center;
		
		.upload{
			width: 100%;
			height: 100%;
		}
		.qrcode_img{
			width: 120px;
			height: 90px;
			//margin: 0 auto;
			
			span{
				line-height: 220px;
			}
			img{
				width: 120px;
				height: 90px;
				position: relative;
				top: -255px;
			}
		}
	}
	/deep/div.van-goods-action{
		background-color: #200a6e !important;
	}
</style>
